import { Component } from '@ribajs/core'
import { SbCartComponent } from './sb-cart.component.js'
import { ShopifyProductService } from '../services/index.js'

import type { ShopifyCartLineItem } from '../types'

interface Scope {
  item?: ShopifyCartLineItem
  removeItem: SbCartLineItem['removeItem']
  increaseItem: SbCartLineItem['increaseItem']
  decreaseItem: SbCartLineItem['decreaseItem']
}

export class SbCartLineItem extends Component {
  public static tagName = 'sb-cart-line-item'

  parent?: SbCartComponent

  public scope: Scope = {
    item: undefined,
    removeItem: this.removeItem.bind(this),
    increaseItem: this.increaseItem.bind(this),
    decreaseItem: this.decreaseItem.bind(this),
  }

  static get observedAttributes(): string[] {
    return ['item']
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbCartLineItem.observedAttributes)
  }

  protected async beforeBind() {
    await super.beforeBind()
    this.parent =
      this.closest<SbCartComponent>(SbCartComponent.tagName) || undefined
    if (!this.parent) {
      throw new Error('sb-cart-line-item must be a child of sb-cart')
    }

    this.prepareMetafield()
  }

  protected async afterBind() {
    this.debug('afterBind', this.scope)
    this.classList.add(`${SbCartLineItem.tagName}-ready`)
    await super.afterBind()
  }

  protected async prepareMetafield() {
    const metafields = await ShopifyProductService.getMetafields(
      this.scope.item!.handle,
    )
    if (!metafields) return
    const bgColor = ShopifyProductService.getBgColorFromMetafields(metafields)
    if (bgColor) ShopifyProductService.setImageBgColor(this, bgColor)
  }

  public async removeItem(lineItem: ShopifyCartLineItem) {
    this.parent?.removeItem(lineItem)
  }

  public async increaseItem(lineItem: ShopifyCartLineItem) {
    this.parent?.increaseItem(lineItem)
  }

  public async decreaseItem(lineItem: ShopifyCartLineItem) {
    this.parent?.decreaseItem(lineItem)
  }

  protected template() {
    return null
  }
}
